import React from "react";

const UserManager = () => {
  return <div>UserManager</div>;
};

export default UserManager;
